module.exports = __webpack_public_path__ + "img/ltri8xJiqO.5a28ccae.png";